var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = __WEBPACK_EXTERNAL_MODULE_https_mfe_dev_webpress_vn_auth_remoteEntry_js_f6451a87__;